import { countDecimals } from '.';
import { SliderInputValue } from '../models';

export const round = (value: number, digit: number) => Math.round(value * Math.pow(10, digit)) / Math.pow(10, digit);

export const ceil = (value: number, digit: number) => Math.ceil(value * Math.pow(10, digit)) / Math.pow(10, digit);

export const floor = (value: number, digit: number) => Math.floor(value * Math.pow(10, digit)) / Math.pow(10, digit);

export const excelCeil = (value: number, significance: number) => round(Math.ceil(value / significance) * significance, countDecimals(significance));

export const excelFloor = (value: number, significance: number) => round(Math.floor(value / significance) * significance, countDecimals(significance));

export const torqueRound = (value: number) => value && parseFloat(value.toFixed(1));

export const currentRound = (value: number) => value && parseFloat(value.toFixed(2));

export const powerRound = (value: number) => value && parseFloat(value.toFixed(2));

export const speedRound = (value: number) => value && parseFloat(value.toFixed(0));

export const torqueRoundToString = (value: number) => value && value.toFixed(1);

export const currentRoundToString = (value: number) => value && value.toFixed(2);

export const powerRoundToString = (value: number) => value && value.toFixed(2);

export const timeRound = (value: number) => value && parseFloat(value.toFixed(2));

export const speedRoundToString = (value: number) => value && value.toFixed(0);

export const percentageRound = (value: number) => excelCeil(value, 0.25);

export const startupsRound = (value: number) => excelFloor(value, 1);

export const relatedValuesRound = (value: number) => round(value, 1);

export const mapToSliderInputText = (value: number): SliderInputValue => {
    return ({ sliderValue: value, inputValue: round(value, 2).toString() });
};

export const fixNumberZeroFormat = (value: string) => {
    while (value.startsWith('0')) {
        if (value === '0') {
            break;
        }

        if (value.startsWith('0.')) {
            break;
        }

        value = value.substring(1);
    }

    return value;
};

export const setStringDecimalCount = (value: string, count: number) => {
    const decimalCount = !isNaN(Number(value)) && countDecimals(Number(value));
    const zeroPattern = `.${new Array(count + 1).join('0')}`;

    if (decimalCount || value.includes(zeroPattern)) {
        const dotIndex = value.indexOf('.') + 1;

        return value.substring(0, dotIndex + count);
    } else {
        return value;
    }
};
